import React from 'react'
import PropTypes from 'prop-types'
import { token } from '@planningcenter/tapestry'
import { Box } from '@planningcenter/tapestry-react'

import CaretDownIcon from '~/explorer/components/icons/caret_down_icon.jsx'

const Link = ({ level, selected, inCurrentPath, visited, ...props }) => {
  const styles = {
    background: token('--t-surface-color-card'),
    borderBottom: `1px solid ${token('--t-border-color')}`,
    display: 'flex',
    '&:hover': {
      background: token('--t-fill-color-button-interaction-ghost-hover'),
      color: '#4e91b5',
      cursor: 'pointer',
    },
    fontSize: '12px',
    lineHeight: '16px',
    padding: '8px 8px 7px',
    ...(level && {
      padding: `8px 8px 7px ${12 + 8 * level}px`,
      ...(level === 1 && {
        fontSize: '16px',
        fontWeight: '700',
        lineHeight: '24px',
      }),
    }),
    ...(visited && { fontWeight: 'bold' }),
    ...(selected && {
      background: token('--t-fill-color-button-interaction-ghost-active'),
    }),
  }
  return <Box css={styles} {...props} />
}

const Name = (props) => {
  const styles = { flex: '1', marginLeft: '0.3em' }
  return <Box css={styles} {...props} />
}

const CaretToggle = ({ expanded, ...props }) => {
  const rotation = expanded ? 0 : -90

  const styles = {
    marginLeft: '-1em',
    transition: 'transform .1s ease-in-out',
    transform: `rotate(${rotation}deg)`,
  }
  return <CaretDownIcon css={styles} {...props} />
}

const NavLink = ({
  children,
  level,
  selected,
  expanded,
  hasChildren,
  onCaretClick,
  style = {},
  ...props
}) => {
  return (
    <Link style={style} {...props} level={level} selected={selected}>
      {hasChildren && (
        <CaretToggle
          color={token('--t-text-color-inverted')}
          expanded={expanded}
          onClick={onCaretClick}
        />
      )}
      <Name>{children}</Name>
    </Link>
  )
}

NavLink.propTypes = {
  link: PropTypes.bool,
  selected: PropTypes.bool,
  style: PropTypes.object,
}

export default NavLink
